import * as React from "react";
import { SVGProps } from "react";

const SvgFourHearts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 248 347"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M237.8.8H10.1S.5 1.1.5 13.7v319.7c0 12.6 9.5 12.9 9.5 12.9h227.8s9.5-.3 9.5-12.9V13.7c0-12.6-9.5-12.9-9.5-12.9Z"
      fill="#fff"
    />
    <mask
      id="four-hearts_svg__b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={187}
      width={248}
      height={160}
    >
      <path
        d="M146.1 187.2H.6v146.1c0 12.6 9.5 12.9 9.5 12.9h227.6s9.5-.3 9.5-12.9V187.2H146.1Z"
        fill="url(#four-hearts_svg__a)"
      />
    </mask>
    <g mask="url(#four-hearts_svg__b)">
      <path
        d="M146.1 187.2H.6v146.1c0 12.6 9.5 12.9 9.5 12.9h227.6s9.5-.3 9.5-12.9V187.2H146.1Z"
        fill="url(#four-hearts_svg__c)"
      />
    </g>
    <mask
      id="four-hearts_svg__e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={248}
      height={174}
    >
      <path
        d="M.6 173.1H247.3V13.7c0-12.6-9.5-12.9-9.5-12.9H10.1S.5 1.1.5 13.7v159.4h.1Z"
        fill="url(#four-hearts_svg__d)"
      />
    </mask>
    <g mask="url(#four-hearts_svg__e)">
      <path
        d="M.6 173.1H247.3V13.7c0-12.6-9.5-12.9-9.5-12.9H10.1S.5 1.1.5 13.7v159.4h.1Z"
        fill="url(#four-hearts_svg__f)"
      />
    </g>
    <mask
      id="four-hearts_svg__h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={5}
      y={0}
      width={243}
      height={347}
    >
      <path
        d="M246.8 13.7v319.1c0 12.6-9.6 12.9-9.6 12.9H9.4s-2.1-.1-4.3-1.4c2.5 1.8 5 1.9 5 1.9h227.7s9.6-.3 9.6-12.9V13.7c0-12.6-9.6-12.9-9.6-12.9h-.5s9.5.3 9.5 12.9Z"
        fill="url(#four-hearts_svg__g)"
      />
    </mask>
    <g mask="url(#four-hearts_svg__h)">
      <path
        d="M246.8 13.7v319.1c0 12.6-9.6 12.9-9.6 12.9H9.4s-2.1-.1-4.3-1.4c2.5 1.8 5 1.9 5 1.9h227.7s9.6-.3 9.6-12.9V13.7c0-12.6-9.6-12.9-9.6-12.9h-.5s9.5.3 9.5 12.9Z"
        fill="url(#four-hearts_svg__i)"
      />
    </g>
    <mask
      id="four-hearts_svg__k"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={243}
      height={347}
    >
      <path
        d="M1.1 333.4V14.2c0-12.6 9.6-12.9 9.6-12.9H238.6s2.1.1 4.3 1.4c-2.5-1.8-5-1.9-5-1.9H10.1S.5 1.1.5 13.7v319.7c0 12.6 9.5 12.9 9.5 12.9h.5c.1-.1-9.4-.3-9.4-12.9Z"
        fill="url(#four-hearts_svg__j)"
      />
    </mask>
    <g mask="url(#four-hearts_svg__k)">
      <path
        d="M1.1 333.4V14.2c0-12.6 9.6-12.9 9.6-12.9H238.6s2.1.1 4.3 1.4c-2.5-1.8-5-1.9-5-1.9H10.1S.5 1.1.5 13.7v319.7c0 12.6 9.5 12.9 9.5 12.9h.5c.1-.1-9.4-.3-9.4-12.9Z"
        fill="url(#four-hearts_svg__l)"
      />
      <mask
        id="four-hearts_svg__n"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={25}
        width={2}
        height={299}
      >
        <path
          d="M.6 25.8v297.9c.2-.6.3-1.2.5-1.8V31.2c-.2-1.8-.4-3.6-.5-5.4Z"
          fill="url(#four-hearts_svg__m)"
        />
      </mask>
      <g mask="url(#four-hearts_svg__n)">
        <path
          d="M.6 25.8v297.9c.2-.6.3-1.2.5-1.8V31.2c-.2-1.8-.4-3.6-.5-5.4Z"
          fill="url(#four-hearts_svg__o)"
        />
      </g>
    </g>
    <path
      d="M26.5 67.5c-5.1 3.8-7.7 7.7-7.8 7.8-.1-.1-2.6-4.1-7.8-7.8-5.2-3.8-6.4-8.6-4.5-12.2 1.9-3.6 9.3-5.4 12.3 1.8 3-7.2 10.4-5.4 12.3-1.8 1.9 3.6.7 8.4-4.5 12.2ZM17.6 44.5c.9-.2 1.5-.5 1.8-.8.3-.3.5-.7.6-1.2.1-.5.1-1.3.1-2.4v-3.6H8v-1.6l12.8-19.3h3.1v18.8h.5c.8 0 1.4-.1 1.8-.2.4-.1.7-.3.9-.7.2-.3.5-.8.7-1.5h1.7l-.3 4.5H24v3.6c0 1 0 1.7.1 2.1.1.5.2.8.3 1.1.2.3.4.5.7.7.3.2.8.3 1.4.5v1.1h-8.9v-1.1Zm-6-10.1h8.5V29c0-1.4 0-2.9.1-4.6 0-1.7.1-3 .2-3.8h-.2l-8.5 13.5v.3h-.1ZM219.6 279c5.1-3.8 7.7-7.7 7.8-7.8.1.1 2.6 4.1 7.8 7.8 5.2 3.8 6.4 8.6 4.5 12.2-1.9 3.6-9.3 5.4-12.3-1.8-3 7.2-10.4 5.4-12.3 1.8-1.9-3.6-.7-8.4 4.5-12.2ZM228.4 302c-.9.2-1.5.5-1.8.8-.3.3-.5.7-.6 1.2-.1.5-.1 1.3-.1 2.4v3.6H238v1.6l-12.8 19.3h-3.1v-18.8h-.5c-.8 0-1.4.1-1.8.2-.4.1-.7.3-.9.7-.2.3-.5.8-.7 1.5h-1.7l.3-4.5h5.2v-3.6c0-1 0-1.7-.1-2.1-.1-.5-.2-.8-.3-1.1-.2-.3-.4-.5-.7-.7-.3-.2-.8-.3-1.4-.5v-1.1h8.9v1.1Zm6 10.1h-8.5v5.4c0 1.4 0 2.9-.1 4.6 0 1.7-.1 3-.2 3.8h.2l8.5-13.5v-.3h.1ZM93.6 82.7C83.4 90.2 78.3 98 78.2 98.2c-.1-.2-5.2-8-15.4-15.5-10.4-7.6-12.7-17.1-9-24.2 3.7-7.1 18.5-10.6 24.4 3.6 5.9-14.2 20.7-10.7 24.4-3.6 3.8 7.2 1.4 16.6-9 24.2ZM62.8 264.3c10.2-7.5 15.3-15.3 15.4-15.5.1.2 5.2 8 15.4 15.5 10.4 7.6 12.7 17.1 9 24.2-3.7 7.1-18.5 10.6-24.4-3.6-5.9 14.2-20.7 10.7-24.4 3.6-3.7-7.1-1.3-16.6 9-24.2ZM184.8 82.7c-10.2 7.5-15.3 15.3-15.4 15.5-.1-.2-5.2-8-15.4-15.5-10.4-7.6-12.7-17.1-9-24.2 3.7-7.1 18.5-10.6 24.4 3.6 5.9-14.2 20.7-10.7 24.4-3.6 3.7 7.2 1.4 16.6-9 24.2ZM154 264.3c10.2-7.5 15.3-15.3 15.4-15.5.1.2 5.2 8 15.4 15.5 10.4 7.6 12.7 17.1 9 24.2-3.7 7.1-18.5 10.6-24.4-3.6-5.9 14.2-20.7 10.7-24.4 3.6-3.7-7.1-1.4-16.6 9-24.2Z"
      fill="#FF2601"
    />
    <defs>
      <radialGradient
        id="four-hearts_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(120.132 -116.964) scale(499.516)"
      >
        <stop offset={0.616} />
        <stop offset={0.752} stopColor="#020202" />
        <stop offset={0.804} stopColor="#090909" />
        <stop offset={0.841} stopColor="#151515" />
        <stop offset={0.872} stopColor="#262626" />
        <stop offset={0.899} stopColor="#3C3C3C" />
        <stop offset={0.922} stopColor="#585858" />
        <stop offset={0.944} stopColor="#797979" />
        <stop offset={0.963} stopColor="#9F9F9F" />
        <stop offset={0.982} stopColor="#CBCBCB" />
        <stop offset={0.998} stopColor="#F9F9F9" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="four-hearts_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(120.132 -116.964) scale(499.516)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.788} stopColor="#FDFDFD" />
        <stop offset={0.854} stopColor="#F6F6F6" />
        <stop offset={0.901} stopColor="#EAEAEA" />
        <stop offset={0.94} stopColor="#D9D9D9" />
        <stop offset={0.974} stopColor="#C3C3C3" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="four-hearts_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(125.074 319.576) scale(357.937)"
      >
        <stop offset={0.616} />
        <stop offset={0.71} stopColor="#020202" />
        <stop offset={0.762} stopColor="#0A0A0A" />
        <stop offset={0.805} stopColor="#181818" />
        <stop offset={0.842} stopColor="#2C2C2C" />
        <stop offset={0.875} stopColor="#464646" />
        <stop offset={0.906} stopColor="#656565" />
        <stop offset={0.935} stopColor="#8A8A8A" />
        <stop offset={0.963} stopColor="#B6B6B6" />
        <stop offset={0.988} stopColor="#E5E5E5" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="four-hearts_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(125.074 319.576) scale(357.937)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.747} stopColor="#FDFDFD" />
        <stop offset={0.821} stopColor="#F5F5F5" />
        <stop offset={0.88} stopColor="#E7E7E7" />
        <stop offset={0.932} stopColor="#D3D3D3" />
        <stop offset={0.978} stopColor="#BABABA" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="four-hearts_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-9.977 .645) scale(397.434)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="four-hearts_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-9.977 .645) scale(397.434)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="four-hearts_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(67.975 101.334) scale(338.507)"
      >
        <stop />
        <stop offset={0.007} stopColor="#090909" />
        <stop offset={0.048} stopColor="#373737" />
        <stop offset={0.093} stopColor="#626262" />
        <stop offset={0.142} stopColor="#888" />
        <stop offset={0.195} stopColor="#A8A8A8" />
        <stop offset={0.254} stopColor="#C4C4C4" />
        <stop offset={0.32} stopColor="#DADADA" />
        <stop offset={0.397} stopColor="#EBEBEB" />
        <stop offset={0.493} stopColor="#F6F6F6" />
        <stop offset={0.627} stopColor="#FDFDFD" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="four-hearts_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(67.975 101.334) scale(338.507)"
      >
        <stop stopColor="#fff" />
        <stop offset={0.141} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="four-hearts_svg__m"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 128.89 .322) scale(397.383)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="four-hearts_svg__o"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 128.89 .322) scale(397.383)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgFourHearts;
